import React, { useState } from 'react'
import ReactGA from 'react-ga'
import UserInformation from './components/UserInformation'
import CarrierInformation from './components/CarrierInformation'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import ProfileTopbar from './components/ProfileTopbar'
import { useTheme } from '../../theming/ThemeProvider'
import TopTabBarNavigation from '../../navigation/layouts/Main/TopTabBarNavigation'
import { NeedHelpModal } from '../../components'
import { Platform, View, StyleSheet, ScrollView } from 'react-native'
import { usePlatforms } from '../../hooks/usePlatforms'

const Tab = createMaterialTopTabNavigator()
ReactGA.pageview('/profile')

const Profile = () => {
  const { theme } = useTheme()
  const { isDesktop } = usePlatforms()
  const [openModal, setOpenModal] = useState(false)

  const handleModal = () => {
    setOpenModal(!openModal)
  }

  return (
    <View style={{ flex: 1, backgroundColor: theme.WHITE }}>
      <ScrollView>
        <ProfileTopbar handleHelpModal={handleModal} />
        {!isDesktop ? (
          <Tab.Navigator
            tabBar={props => <TopTabBarNavigation {...props} showSearch={false} />}
            sceneContainerStyle={{
              backgroundColor: theme.WHITE
            }}
            swipeEnabled={Platform.OS !== 'web'}
          >
            <Tab.Screen
              name='user' options={{ tabBarLabel: 'Account Settings' }}
              component={UserInformation}
            />
            <Tab.Screen
              name='carrier' options={{ tabBarLabel: 'Carrier information' }}
              component={CarrierInformation}
            />
          </Tab.Navigator>
        ) : (
          <View style={styles.container}>
            <View style={{ flex: 2 }}>
              <UserInformation />
            </View>
            <View style={{ flex: 3 }}>
              <CarrierInformation />
            </View>
          </View>
        )}
      </ScrollView>
      <NeedHelpModal
        open={openModal}
        onClose={handleModal}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignSelf: 'center',
    flex: 1,
    maxWidth: 1000,
    width: '100%'
  }
})

export default Profile
